import React from 'react';

/*
 * The web chat channel, reached from a phone.
 *
 * The globe WebchatIcon draws, at nearly its full size and in the middle of the
 * box, with the phone sitting on it at the foot: the base says which channel,
 * the badge says which device, and the pair is read at a glance because the
 * globe is the same globe.
 *
 * It was drawn shrunk into the top-left corner with the phone off in the other
 * one, so that the two never touched. They never touched, and they never looked
 * like one mark either - two small things at opposite ends of an empty box.
 *
 * Overlapping them needs the globe cut away behind the phone, or the phone's
 * outline crosses the globe's arcs and both turn to mush at the 20px this is
 * drawn at in the history and block lists. That is what the mask does, and the
 * gap it leaves is 1.5 units - about a pixel and a quarter at that size, which
 * is what keeps the two readable as separate things.
 *
 * The id is safe to be a constant. Fifty rows drawing this icon means fifty
 * elements claiming one id, and every one of them resolves to a mask identical
 * to the one it wanted. The collision that broke the Viber and Webex marks was a
 * different thing: several DIFFERENT drawings sharing names like "paint0_linear".
 */
const WebchatMobileIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
         strokeLinejoin="round"
    >
        <mask id="webchatMobileCut">
            <rect width="24" height="24" fill="#fff"/>
            {/* the hole the phone stands in, 1.5 units larger than the phone on
                every side - that margin is the daylight between the two */}
            <rect x="10.75" y="11.75" width="11.5" height="13.5" rx="3" fill="#000"/>
        </mask>

        {/* the globe: the same three strokes as GlobeIcon, at r 8.5 instead of 10 */}
        <g mask="url(#webchatMobileCut)">
            <circle cx="12" cy="11" r="8.5"/>
            <path d="M3.5 11h17"/>
            <path d="M12 2.5a12.3 12.3 0 0 0 0 17 12.3 12.3 0 0 0 0-17"/>
        </g>

        {/* the phone. The bar along its foot is what keeps it from reading as a
            plain rounded box at small sizes */}
        <rect x="13" y="14" width="7" height="9" rx="1.5"/>
        <path d="M15 21.5h3"/>
    </svg>
);

export default WebchatMobileIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/platforms/WebchatMobileIcon.jsx